import React, { Component } from "react";
import "./EditProfile.css";
import UserProfile from "./UserProfile";
import ProfessionalDetails from "./ProfessionalDetails";
import LoaderButton from "../components/LoaderButton";
import config from "../config";
import { API } from "aws-amplify";
import { s3Upload } from "../libs/awsLib";



export default class SingleOccupancy extends Component {

validateForm(){
  return true;
}

constructor(props){
  super(props);

  this.pay1nighthotel = React.createRef();
  this.pay2nightshotel = React.createRef();
  this.paypreconftoo = React.createRef();


  this.state = {
      isLoading: false,
      fullname : "",
      age: "",
      otherpersonname: "NA",
      otherpersonphone: "NA",
      secondpersonname: "NA",
      secondpersonphone: "NA",
      gender: "Female",
      medicalregno: "",
      hospital: "",
      delegatetype: "Presenter",
      food: "Vegetarian",
      nights: this.props.nights,
      totalPayment: this.props.nights === 1 ? "12,000" : "10,000",

      preconference: "false",
      preconferenceUI: false,
      hotelUI: false,
      reservationType: "SingleOccupancy",
      hotelBooking: "1 Night"

  };


}

handleChange = event => {
  this.setState({
    [event.target.id]: event.target.value
  });

}

handleWorkshop = event => {

  if(!this.state.preconferenceUI){

    this.setState({
      preconferenceUI: true,
      preconference: "true",
      totalPayment: "11,500"
    });

  }else{
    this.setState({
      preconferenceUI: false,
      preconference: "false",
      hotelUI: false,
      hotelBooking: "1 Night",
      totalPayment: "12,000"
    });
  }
}

handleHotel = event => {

  if(!this.state.hotelUI){

    this.setState({
       hotelUI: true,
       totalPayment: "10,000",
       hotelBooking: "2 Nights"

    });
  }else{
    this.setState({
      hotelUI: false,
      totalPayment: "12,000",
      hotelBooking: "1 Night"
    })
  }
}

handlePreconference = event => {

  var payment = "12,000";
  if(!this.state[event.target.id+"UI"]){
    payment = "11,500";
  }

  this.setState({
    [event.target.id]: !this.state[event.target.id+"UI"]+"",
    [event.target.id+"UI"]: !this.state[event.target.id+"UI"],
    totalPayment: payment
  });


}


submitPersonalDetails = async event => {
    event.preventDefault();

   try{
      var isAnythingChanged = false;
      if(this.state.fullname.length === 0){
        this.setState({errorMsg: "Please enter your name"});
        return;
      }

      if(this.state.age.length === 0){
        this.setState({errorMsg: "Please enter your age"});
        return;
      }


      if(this.state.medicalregno.length === 0){
        this.setState({errorMsg: "Please enter your medical council registration number"});
        return;
      }

      if(this.state.hospital.length === 0){
        this.setState({errorMsg: "Please enter the hosptial where you work"});
        return;
      }

      if(this.state.otherpersonname.length === 0){
        this.state.otherpersonname = "Single Occupancy";
      }
      this.setState({isLoading: true});
      await this.createBooking(this.state);

      if(this.state.nights === 2){
          this.pay2nightshotel.current.click();
      }else {
          this.pay1nighthotel.current.click();
      }


      // if(this.state.totalPayment === "16,500"){
      //   this.pay2nightshotel.current.click();
      // }else
       //
      //  if(this.state.totalPayment === "11,500"){
      //   this.paypreconftoo.current.click();
      // }else if(this.state.totalPayment === "10,500"){
      //   this.pay1nighthotel.current.click();
      // }



    }catch(e){

      this.setState({isLoading: false, errorMsg: "Something went wrong. Please contact our support team."});
    }
 }

  async createBooking(bookingDetails){
    var registrationDetails = await API.post("retnetindia", "/register4retnet", {
      body: bookingDetails
    });
    localStorage.setItem("registrationId", registrationDetails.registrationId);
    return registrationDetails;
  }

  getSuccessNotification(successMsg){
    return this.state.successMsg && this.state.successMsg.length > 0
                            ? <div className="alert alert-success" role="alert">
                                {this.state.successMsg}
                              </div>
                            : "";
  }

  getErrorElement(){
     return this.state.errorMsg && this.state.errorMsg.length > 0
                             ? <div className="alert alert-danger" role="alert">
                                 {this.state.errorMsg}
                               </div>
                             : "";
  }



render() {

    return(
      <div className="container">

            <div className="retnet-center-text retnet2020title">
                For any queries or concerns please contact &nbsp;
                <b>Dr. Divyansh Mishra (+91-8977405171)</b> or <b> Mr. Ravindra (+91-9880541133) </b>
            </div>
            <div className="row ">
                    <div className="col-md-2"></div>
                  <div className="col-md-8">
                        <div className="card">
                          <div className="card-title b-xs-bottom">
                              <h3 className="retnet-center-text">RETNET INDIA MEET 2024</h3>
                              <p className="retnet-center-text">
                                  Retnet Conference + Single Occupancy Room Reservation
                                  {
                                      this.state.nights === 2 ? <span> (2 nights) </span> : <span> (1 night) </span>
                                  }
                              </p>

                          </div>
                          <div className="card-body">
                              {this.getErrorElement()}
                              {this.getSuccessNotification()}
                              <form id="personal-details-form"
                                    onSubmit={this.submitPersonalDetails}>

                                    <div className="row">
                                        <div className="col-md-6">
                                              <div className="form-group">
                                                  <label for="fullname"><span className="retnet2020title">*&nbsp;</span>Full Name</label>
                                                  <input type="text" id="fullname"
                                                       className="form-control"
                                                       placeholder=""
                                                       onChange={this.handleChange} />
                                              </div>
                                        </div>
                                        <div className="col-md-6">
                                              <div className="form-group">
                                                  <label for="gender">Select Gender</label>
                                                  <select className="form-control"
                                                          id="gender"
                                                          onChange={this.handleChange}>
                                                      <option value="Female">Female</option>
                                                      <option value="Male">Male</option>

                                                  </select>
                                              </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                              <div className="form-group">
                                                  <label for="age"><span className="retnet2020title">*&nbsp;</span>Age</label>
                                                  <input type="number" id="age"
                                                       className="form-control"
                                                       placeholder=""
                                                       onChange={this.handleChange} />
                                              </div>
                                        </div>
                                        <div className="col-md-6">
                                              <div className="form-group">

                                                  <label for="food">Food Preference</label>
                                                  <select className="form-control"
                                                          id="food"
                                                          onChange={this.handleChange}>
                                                      <option value="Vegetarian">Vegetarian</option>
                                                      <option value="NonVegetarian">Non Vegetarian</option>

                                                  </select>

                                              </div>
                                        </div>
                                    </div>

                                    <br/>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label for="medicalregno"><span className="retnet2020title">*&nbsp;</span>Medical Council Reg No</label>
                                                <input type="text" id="medicalregno"
                                                     className="form-control"
                                                     placeholder=""
                                                     onChange={this.handleChange} />
                                            </div>

                                        </div>
                                        <div className="col-md-6">

                                            <div className="form-group">
                                                <label for="hospital"><span className="retnet2020title">*&nbsp;</span>Working Hospital</label>
                                                <input type="text" id="hospital"
                                                     className="form-control"
                                                     placeholder=""
                                                     onChange={this.handleChange} />
                                            </div>

                                        </div>
                                    </div>

                                    {/*<div className="checkbox">*/}
                                    {/*   <input type="checkbox"*/}
                                    {/*          name="preconference"*/}
                                    {/*          onChange={this.handleWorkshop}*/}
                                    {/*          checked={this.state.preconferenceUI}*/}
                                    {/*          id="preconference"  />*/}

                                    {/*      <label for="preconference" className="retnet2020title preconferenceText" >*/}
                                    {/*          Include Pre-Conference Workshop on Diabetic Vitrectomy on 6th at 9 AM &nbsp; <b className="blink_me"> (+ &#x20B9;1,000) </b>*/}
                                    {/*          Limited Seats Available*/}
                                    {/*     </label>*/}
                                    {/*</div>*/}

                                    {/*<div className="checkbox">*/}
                                    {/*   <input type="checkbox"*/}
                                    {/*          name="hotel"*/}
                                    {/*          onChange={this.handleHotel}*/}
                                    {/*          checked={this.state.hotelUI}*/}
                                    {/*          id="hotel"  disabled={!this.state.preconferenceUI}/>*/}

                                    {/*     <label for="hotel" className="retnet2020title preconferenceText" >*/}
                                    {/*         Book the Room from 12th night to attend Pre-Conference Workshop &nbsp; <b className="blink_me">(+ &#x20B9;6,500) </b>*/}
                                    {/*    </label>*/}

                                    {/*</div>*/}
                                    <br />

                                    Charges Includes:
                                  {
                                      this.state.nights === 2
                                          ? <ul>
                                              <li>Conference Registration</li>
                                              <li>Hotel Check in June 7th at 3 pm</li>
                                              <li>Hotel Check out June 8th by 12pm </li>
                                              <li> June 7th - Dinner</li>
                                              <li> June 8th - Breakfast</li>
                                              {/*<li> July 23rd - Breakfast & Lunch</li>*/}
                                          </ul>
                                          : <ul>
                                              <li>Conference Registration</li>
                                              <li>Hotel Check in June 8th at 3 pm</li>
                                              <li>Hotel Check out June 9th by 12pm </li>
                                              <li> June 8th - Lunch & Dinner</li>
                                              <li> June 9th - Breakfast & Lunch</li>
                                          </ul>

                                  }
                                    {/*<ul >*/}
                                    {/*    <li>Conference Registration</li>*/}
                                    {/*    {this.state.totalPayment == "16,500" ? <li className="retnet2020title">Hotel Check in August 6th at 3 pm</li>*/}
                                    {/*          : <li>Hotel Check in August 6th at 3pm </li>*/}
                                    {/*    }*/}

                                    {/*    <li>Hotel Check out August 7th by 12pm </li>*/}
                                    {/*    <li>August 6th - Lunch & Dinner</li>*/}
                                    {/*    <li>August 7th - Breakfast & Lunch</li>*/}
                                    {/*    {this.state.totalPayment == "11,500" || this.state.totalPayment == "16,500"*/}
                                    {/*          ? <span> <li> Pre Conference Workshop On 6th at 9 AM To 12 PM</li>*/}
                                    {/*            <li> August 6th - Breakfast Included</li> </span>*/}
                                    {/*          : <span></span>*/}
                                    {/*    }*/}
                                    {/*    {this.state.totalPayment == "16,500"*/}
                                    {/*          ?  <li> June 12th - Dinner Included</li>*/}
                                    {/*          : <span></span>*/}
                                    {/*    }*/}


                                    {/*</ul>*/}

                                    <div className="form-group align-center">
                                        <h4>Your Total Payment : &#x20B9; {this.state.totalPayment}</h4>
                                        <LoaderButton ref={this.withpreconference} block bsStyle="primary" bsSize="large"
                                              disable={!this.validateForm()} type="submit"
                                              isLoading={this.state.isLoading} text="Pay Now"
                                              loadingText="Updating Details..."
                                              className="btn btn-primary"/>


                                          <div hidden>

                                              <a href="https://www.instamojo.com/@retnetindia/lc58be4bea9ae4778a5c976e12fe58f2e/"
                                                    rel="im-checkout" data-behaviour="remote"
                                                     className="btn btn-success"
                                                     data-style="light"
                                                     ref={this.paynow}
                                                     data-text="Register Now">
                                                     Register Now
                                              </a>
                                          </div>
                                          <div hidden>

                                          <a href="https://imjo.in/GFU23A"
                                                rel="im-checkout" data-text="Pay"
                                                ref={this.pay1nighthotel}
                                                data-css-style="color:#ffffff; background:#75c26a; width:300px; border-radius:4px"
                                                data-description="
                                                Conference Registration
                                                Hotel Check in June 8th at 3pm
                                                Hotel Check out June 9th by 12pm
                                                June 8th - Lunch & Dinner
                                                June 9th - Breakfast & Lunch" data-layout="vertical">
                                          </a>

                                          <a href="https://imjo.in/AXg273"
                                                rel="im-checkout" data-text="Pay"
                                                ref={this.paypreconftoo}
                                                data-css-style="color:#ffffff; background:#75c26a; width:300px; border-radius:4px"
                                                data-description="Conference Registration
                                                Hotel Check in July 21st at 3pm -  Checkout 23rd by 12 pm
                                                July 21st - Dinner
                                                July 22nd - Breakfast, Lunch & Dinner
                                                July 23rd - Breakfast & Lunch
                                                Pre Conference Workshop 6th 9 AM To 12 PM" data-layout="vertical">
                                          </a>

                                          <a href="https://imjo.in/T26DKW"
                                                  rel="im-checkout" data-text="Pay"
                                                  ref={this.pay2nightshotel}
                                                  data-css-style="color:#ffffff; background:#75c26a; width:300px; border-radius:4px"
                                                  data-description="Conference Registration
                                                  Hotel Check in June 7th at 3pm -  Checkout June 8th by 12 pm
                                                  June 7th - Dinner
                                                  June 8th - Breakfast" data-layout="vertical">
                                          </a>
                                      </div>



                                    </div>
                              </form>
                              <div className="checkbox">
                                 <input type="checkbox"
                                        name="newsletter"
                                        id="newsletter"  />
                                   <label for="newsletter" className="" >
                                       I want to subscribe for RETNET Conference Newsletter.
                                  </label>
                              </div>
                              <br />
                              <div className="retnet2020title">* Indicates Mandatory Fields
                              </div>

                          </div>
                        </div>
                  </div>
                <div className="col-md-2"></div>
                  {/*<div className="col-md-4">*/}
                  {/*    <img className="retnet-banner" src="/images/preconferenceworkshop.jpg"  />*/}
                  {/*</div>*/}

            </div>
      <br />
      <br />
     </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/SingleOccupancy.js